<div class="container-page p-0">
    <div class="container-page p-0">
        <lib-hygiene-check-form></lib-hygiene-check-form>
    </div>
</div>